/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */


export function escapeRegex(value: string) {
  return value && value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
